<i18n src="@/locales/modules/DeviceTranslate.json"></i18n>

<template>
	<div :key="deviceCategoryIdRoute || 'default'" id="list-devices" class="data-list-container">
		<device-list-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" @refetchDataList="getListDevices(true)" :data="sidebarData" />

		<device-detail-sidebar
			ref="device-detail"
			:data="detailSidebarData"
			:isSidebarActive="isShowDetailDialog"
			@onClickEdit="editData"
			@onClickDelete="showDeleteConfirm"
			@closeSidebar="toggleDetailSidebar"
			@onClickCreateTodo="handleClickCreateTodo"
			@onClickManageAccessories="manageAccessories"
			@onClickCreateRequest="handleClickCreateRequest"
			@onClickManageChecklist="device => manageChecklist(device.category.id, device.kpis)"
			@editDataAccessory="manageAccessories"
			@onClickCloneKpis="handleCloneKpis"
			@onClickCreateKpis="handleCreateKpi"
			@onClickResetKpiHour="handleResetKpiHour"
		/>

		<device-checklist-sidebar :isSidebarActive="checklistSidebar" @closeSidebar="toggleChecklistSidebar" :data="kpiData" />

		<device-category-sidebar :isSidebarActive="categorySidebar" @closeSidebar="toggleCategorySidebar" @manageChecklist="manageChecklist" />

		<device-inventory-sidebar :isSidebarActive="inventorySidebar" @closeSidebar="toggleInventorySidebar" />

		<!-- <device-accessory-dialog :isDialogActive="accessoryDialog" @closeDialog="toggleAccessoryDialog" :data="accessoryData" /> -->
		<popup-create-or-update-accessory :isPopupActive="accessoryDialog" @closePopup="toggleAccessoryDialog" :data="accessoryData" />
		<popup-create-or-update-kpi-for-device :isPopupActive="kpiDialog" @closePopup="toggleKpiDialog" :data="kpiDeviceData" />

		<request-form-dialog
			v-if="isShowRequestFormDialogMixin"
			v-model="activeRequestMixin"
			:stepsData="stepsDataMixin"
			:activeStepId="activeStepIdMixin"
			:requestTypes="requestTypesMixin"
			:relationsData="requestRelationsData"
			:isDialogActive="isShowRequestFormDialogMixin"
			:key="activeRequestMixin && activeRequestMixin.id ? activeRequestMixin.id : 'default'"
			@closeDialog="toggleRequestFormDialogMixin"
			@onIsFormDirtyChange="handleSetIsFormDirty"
			@onChangeRequestType="handleChangeRequestTypeMixin"
			@onClickSubmit="handleClickSubmitRequestFormDialog"
			@onFocusSelectRequestTypes="handleOnFocusSelectRequestTypesMixin"
		/>

		<TodoListFormSidebar :data="todoFormDialogData" :isSidebarActive="isTodoFormDialogActive" @closeSidebar="toggleFormCreateTodo" @onCreateOrUpdateSuccess="handleOnCreateTodoSuccess" />

		<div class="empty-data text-center" v-if="isFetchedDevices && !devices.length && !searchText && !isSearching">
			<p class="flex justify-center items-center flex-wrap">
				<span>Chưa có dữ liệu.</span>
				<span class="ml-1 flex" v-if="mixinIsCanCreateDevice">
					Nhấn vào nút
					<i class="nucleo nucleo-c-add-2"></i> để tạo thiết bị!
				</span>
			</p>
			<i v-if="mixinIsCanCreateDevice" class="btn-add-device nucleo nucleo-c-add-2" @click="addNewData"></i>
			<img src="@/assets/images/cbs/device/empty-list-data.png" alt class="responsive" />
		</div>

		<div v-else>
			<div class="dropdown-button-container flex justify-end mt-16 md:hidden lg:hidden xl:hidden">
				<cbs-input @input="mixinHandleSearch" size="large" class="input-search mr-3" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />

				<vs-dropdown vs-custom-content vs-trigger-click>
					<vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
					<vs-dropdown-menu>
						<vs-dropdown-item>
							<vs-button v-if="mixinIsCanViewCategory" type="border" class="w-full font-bold mr-3 last:mr-0 whitespace-no-wrap" @click="manageCategories">
								{{ $t("DeviceCategories") }}
							</vs-button>
						</vs-dropdown-item>

						<vs-dropdown-item divider v-if="mixinIsCanViewInventory">
							<vs-button type="border" class="w-full font-bold mr-3 last:mr-0 whitespace-no-wrap" @click="manageInventories">
								{{ $t("InventoryManagement") }}
							</vs-button>
						</vs-dropdown-item>

						<vs-dropdown-item divider>
							<vs-button
								v-if="!!$store.state.deviceManagement.categories.length && mixinIsCanCreateDevice"
								type="filled"
								class="w-full font-bold whitespace-no-wrap"
								@click="addNewData"
								>{{ $t("AddNewDevice") }}</vs-button
							>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<vs-table
				ref="table"
				:sst="true"
				:noDataText="$t('Notify.NoDataAvailable')"
				class="stack-table"
				:max-items="$store.state.deviceManagement.limitPerPage"
				:data="devices"
				@sort="mixinHandleSort"
			>
				<div slot="header" class="flex flex-grow justify-end">
					<cbs-input
						@input="mixinHandleSearch"
						size="large"
						class="input-search mr-3 md:block lg:block xl:block hidden"
						icon="search"
						:placeholder="$t('Actions.Search')"
						v-model="searchText"
					/>
					<div class="md:flex lg:flex xl:flex hidden">
						<vs-button v-if="mixinIsCanViewCategory" type="border" class="w-full sm:w-auto font-bold mr-3 whitespace-no-wrap" @click="manageCategories">
							{{ $t("DeviceCategories") }}
						</vs-button>

						<vs-button v-if="mixinIsCanViewInventory" type="border" class="w-full sm:w-auto font-bold mr-3 whitespace-no-wrap" @click="manageInventories">
							{{ $t("InventoryManagement") }}
						</vs-button>

						<vs-button v-if="!!$store.state.deviceManagement.categories.length && mixinIsCanCreateDevice" type="filled" class="w-full sm:w-auto font-bold" @click="addNewData">
							{{ $t("AddNewDevice") }}</vs-button
						>
					</div>
				</div>

				<template slot="thead">
					<vs-th sort-key="code">{{ $t("Code") }}</vs-th>
					<vs-th sort-key="name">{{ $t("Name") }}</vs-th>
					<vs-th class="no-sorter">{{ $t("Category") }}</vs-th>
					<vs-th class="no-sorter"></vs-th>
				</template>

				<template slot-scope="{ data }">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickDeviceItemRow($event, tr)">
							<vs-td :data-header="$t('Code')">
								<p class="device-name font-medium">{{ tr.code }}</p>
							</vs-td>
							<vs-td :data-header="$t('Name')">
								<p class="device-name font-medium">{{ tr.name }}</p>
							</vs-td>

							<vs-td :data-header="$t('Category')">
								<p class="device-inventory font-medium sm:truncate">{{ tr.category ? tr.category.name : "" }}</p>
							</vs-td>

							<vs-td class="text-right">
								<DeviceContextMenu
									type="vertical"
									:device="tr"
									@onClickEdit="editData"
									@onClickDelete="showDeleteConfirm"
									@onClickCreateTodo="handleClickCreateTodo"
									@onClickManageAccessories="manageAccessories"
									@onClickCreateRequest="handleClickCreateRequest"
									@onClickManageChecklist="device => manageChecklist(device.category.id, device.kpis)"
									@onClickCloneKpis="handleCloneKpis"
									@onClickCreateKpis="handleCreateKpi"
								/>
							</vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
			<CbsPagination class="mt-3" :total="totalPages" v-model="currentPage" />
		</div>
		<KpiResetHour :isDialogActive="isDialogResetKpi" @onClickAgree="resetMaintainHour" @closeDialog="toggleResetDialog" />
	</div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { syncQuery, detectLeavePage, withBasicQueries, devicePermissions, categoryPermissions, getUserPermissions, inventoryPermissions } from "@/mixins/mixins.js";
import { mapGetters } from "vuex";
import moduleDevice from "@/store/device/moduleDevice";
import requestGQL from "@/http/requests/request/request_v2_gql";
import requestBasicHandlers from "@/mixins/requestBasicHandlers";

import DeviceListSidebar from "./DeviceListSidebar";
import DeviceContextMenu from "./DeviceContextMenu";
import DeviceDetailSidebar from "./DeviceDetailSidebar";
import DeviceCategorySidebar from "./DeviceCategorySidebar";
import DeviceChecklistSidebar from "./DeviceChecklistSidebar";
import DeviceInventorySidebar from "./DeviceInventorySidebar";
import RequestFormDialog from "@/components/cbs-request/RequestFormDialog";
import TodoListFormSidebar from "@/views/apps/cbs/todo-list/TodoListFormSidebar";
import PopupCreateOrUpdateAccessory from "./PopupCreateOrUpdateAccessory";
import PopupCreateOrUpdateKpiForDevice from "./PopupCreateOrUpdateKpiForDevice";
import KpiResetHour from "@/components/list-device-kpi/KpiResetHour.vue";
import kpiGql from "@/http/requests/cbs/kpi_gql";

export default {
	mixins: [
		syncQuery,
		withBasicQueries,
		requestBasicHandlers,
		getUserPermissions({
			...devicePermissions,
			...categoryPermissions,
			...inventoryPermissions
		}),
		detectLeavePage("isRequestFormDirty")
	],
	components: {
		DeviceListSidebar,
		DeviceContextMenu,
		RequestFormDialog,
		DeviceDetailSidebar,
		TodoListFormSidebar,
		DeviceCategorySidebar,
		DeviceChecklistSidebar,
		DeviceInventorySidebar,
		PopupCreateOrUpdateAccessory,
		PopupCreateOrUpdateKpiForDevice,
		KpiResetHour
	},
	data() {
		return {
			itemsPerPage: 10,
			isSearching: false,
			detailCode: null,
			relationsDataId: null,

			// Data Sidebar
			addNewDataSidebar: false,
			sidebarData: {},
			isShowDetailDialog: false,
			detailSidebarData: {},
			kpiId: "",
			kpiCategoryId: "",
			accessoryData: {},
			checklistSidebar: false,
			categorySidebar: false,
			inventorySidebar: false,
			accessoryDialog: false,

			isRequestFormDirty: false,
			isTodoFormDialogActive: false,
			todoFormDialogData: {},
			relationDataType: null,
			kpiDialog: false,
			kpiDeviceData: null,
			isDialogResetKpi: false
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.$store.state.deviceManagement.totalDevices / this.$store.state.deviceManagement.limitPerPage);
		},
		...mapGetters({
			getParsedDevices: "deviceManagement/getParsedDevices",
			getParsedDevice: "deviceManagement/getParsedDevice"
		}),
		devices() {
			return this.getParsedDevices || [];
		},
		kpiData() {
			return {
				id: this.kpiId,
				categoryId: this.kpiCategoryId,
				categoryName: this.categoryName
			};
		},
		isFetchedDevices() {
			return _.get(this.$store, "state.deviceManagement.isFetchedDevices") || false;
		},
		listDeviceStatus() {
			return _.get(this.$store, "state.deviceManagement.devicesStatus") || [];
		},
		requestRelationsData() {
			return [
				{
					id: this.relationsDataId,
					type: this.relationDataType
				}
			];
		},

		deviceCategoryIdRoute() {
			return this.$route && this.$route.params && this.$route.params.categoryId;
		},
		pageTitleByCategoryId() {
			const deviceCategory = (this.$store.state.deviceCategories || []).find(category => category.id === Number(this.deviceCategoryIdRoute)) || {};
			return deviceCategory.name;
		}
	},
	watch: {
		currentPage() {
			this.getListDevices();
		},
		"$route.query"(newVal, oldVal) {
			const newValClone = Object.assign({}, newVal);
			const oldValClone = Object.assign({}, oldVal);
			if (!newValClone.code) {
				delete oldValClone.code;
			}
			if (!_.isEqual(newValClone, oldValClone)) {
				this.handleFetchDataByQuery();
			}
		},
		"$route.path"(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.handleFetchDataByQuery();
			}
		},
		pageTitleByCategoryId() {
			this.setPageTitleByCategoryId();
		},
		isShowRequestFormDialogMixin() {
			if (!this.isShowRequestFormDialogMixin) {
				this.handleSetIsFormDirty(false);
			}
		}
	},
	methods: {
		async getListDevices(isRefetch = false) {
			try {
				this.$vs.loading();
				const filter = this.$route.params.filter || {};
				const queryOptions = {
					limit: this.$store.state.deviceManagement.limitPerPage,
					page: this.currentPage,
					orderBy: this.orderBy,
					category_id: this.deviceCategoryIdRoute
				};
				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				if (this.searchText) {
					queryOptions.search = this.searchText;
				}

				// Fetch devices
				await this.$store.dispatch("deviceManagement/fetchDevices", queryOptions);
				if (this.$refs.table && this.searchText) {
					this.$refs.table.currentx = 1;
				}
				this.$store.commit("deviceManagement/UPDATE_DEVICES_FILTER", filter);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		addNewData() {
			this.sidebarData = {};
			this.toggleDataSidebar(true);
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				const result = await this.$store.dispatch("deviceManagement/deleteDevice", id);
				if (result) {
					if (this.$store.state.deviceManagement.devices.length == 0) {
						this.currentPage = this.currentPage === 1 ? 1 : this.currentPage - 1;
						this.getListDevices();
					}
				}
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteDeviceSuccessful")
					}
				});
				if (this.isShowDetailDialog) {
					this.toggleDetailSidebar();
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async editData(id) {
			try {
				this.$vs.loading();
				const selectedDevice = await this.getDevice(id);
				if (!selectedDevice) {
					this.$helper.notifyError({
						context: this,
						options: {
							text: this.$t("DeviceNotFound")
						}
					});
				} else {
					const parsedProperties = _.get(selectedDevice, "properties") ? JSON.parse(_.get(selectedDevice, "properties")) : {};
					console.log("selectedDevice", selectedDevice);
					this.sidebarData = {
						...selectedDevice,
						image: _.get(selectedDevice, "image.path") || null,
						manager_id: (_.get(selectedDevice, "manage_employees.data") || []).map(user => user.id),
						inventory_id: _.get(selectedDevice, "inventories.data.0.id") || null,
						manufacture_year: _.get(parsedProperties, "mfg"),
						warranty: _.get(parsedProperties, "wd"),
						serial: _.get(parsedProperties, "serial"),
						mappedTransitsData: (_.get(parsedProperties, "transits") || []).map(deviceStatusId => {
							const currentDeviceState = _.find(this.listDeviceStatus, { id: selectedDevice.status }) || {};
							return {
								currentDeviceState,
								transitState: _.find(this.listDeviceStatus, { id: deviceStatusId })
							};
						})
					};
					this.toggleDataSidebar(true);
					if (this.isShowDetailDialog) {
						this.toggleDetailSidebar();
					}
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
		toggleDetailSidebar(val = false) {
			if (!val) {
				this.detailId = null;
			}
			this.isShowDetailDialog = val;
		},
		toggleChecklistSidebar(val = false) {
			this.checklistSidebar = val;
		},
		toggleCategorySidebar(val = false) {
			this.categorySidebar = val;
		},
		toggleInventorySidebar(val = false) {
			this.inventorySidebar = val;
		},
		toggleAccessoryDialog(val = false) {
			this.accessoryDialog = val;
		},
		toggleKpiDialog(val = false) {
			this.kpiDialog = val;
		},
		async viewDetail(deviceData) {
			try {
				this.$vs.loading();
				this.detailSidebarData = await this.getDevice(deviceData.id);
				if (!this.detailSidebarData) {
					this.$helper.notifyError({
						context: this,
						options: {
							text: this.$t("DeviceNotFound")
						}
					});
				} else {
					this.toggleDetailSidebar(true);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async manageChecklist(categoryId, kpis, categoryName) {
			this.kpiId = _.get(kpis, "0.id") || "";
			this.kpiCategoryId = categoryId || "";
			this.categoryName = categoryName;
			// if (!this.kpiId) {
			// await this.$store.commit("deviceManagement/SET_KPI_DETAILS", []);
			// }
			this.toggleChecklistSidebar(true);
		},
		manageCategories() {
			this.toggleCategorySidebar(true);
		},
		manageInventories() {
			this.toggleInventorySidebar(true);
		},
		async getDevice(id) {
			try {
				this.$vs.loading();
				const dataDevice = await this.$store.dispatch("deviceManagement/getDevice", id);
				return this.parsedDevice(dataDevice);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		manageAccessories(data) {
			this.accessoryData = data;
			this.toggleAccessoryDialog(true);
		},
		parsedDevice(device) {
			return this.$store.getters["deviceManagement/getParsedDevice"](device);
		},
		handleFetchDataByQuery() {
			this.getListDevices().then(() => {
				if (this.$route.query.id) {
					this.viewDetail({ id: Number(this.$route.query.id) });
				}
			});
		},
		handleClickDeviceItemRow(event, todoItem) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not CbsContextMenu
			if (event.target !== event.currentTarget && !eventClasses.split(" ").includes("cbs-context-menu")) {
				this.viewDetail(todoItem);
			}
		},
		async handleOnCreateRequestOrTodoSuccess(response) {
			if (this.isShowRequestFormDialogMixin) {
				if (this.isShowDetailDialog) {
					this.$refs["device-detail"].onUpdateLogsRequestByRelations(response);
				}
				this.toggleRequestFormDialogMixin(false);
			}
			if (this.isTodoFormDialogActive) {
				if (this.isShowDetailDialog) {
					this.$refs["device-detail"].onUpdateLogsTodoByRelations();
				}
				this.toggleFormCreateTodo(false);
			}
			if (this.isShowDetailDialog) {
				console.log("isShowDetailDialog");
				this.detailSidebarData = await this.getDevice(this.detailSidebarData.id);
				if (this.isDialogResetKpi) {
					this.$refs["device-detail"].onUpdateLogsTodoByRelations();
				}
			}
		},
		handleSetIsFormDirty(isFormDirty) {
			this.isRequestFormDirty = isFormDirty;
		},
		handleClickCreateRequest(relation) {
			this.handleSetInitRequestFormDialogMixin();
			this.relationsDataId = relation.id;
			this.relationDataType = relation.type;
			this.toggleRequestFormDialogMixin(true);
		},
		handleClickCreateTodo(relation) {
			this.relationsDataId = relation.id;
			this.todoFormDialogData = {
				type: this.$constant.TODO_TYPE.NORMAL,
				relations: [{ id: relation.id, type: relation.type ? relation.type : this.$constant.RELATION_MODELS.DEVICE, display: relation.display_name }]
			};
			this.toggleFormCreateTodo(true);
		},
		toggleFormCreateTodo(val = false) {
			this.isTodoFormDialogActive = val;
		},
		setPageTitleByCategoryId() {
			if (this.pageTitleByCategoryId && this.$listeners && this.$listeners.changeRouteTitle) {
				this.$listeners.changeRouteTitle(this.pageTitleByCategoryId);
			}
		},
		formatStepConfigData(configData) {
			return {
				content: _.get(configData, "content"),
				relations: (_.get(configData, "relations") || []).map(option => ({ id: option.id, type: option.type }))
			};
		},
		async handleClickSubmitRequestFormDialog(requestData, dynamicStepConfig, relationsData, resolve) {
			try {
				this.$vs.loading();
				const mappedFormData = {};
				requestData.activeFormData.controls.forEach(field => {
					mappedFormData[field.id] = field.value;
					if (field.control === this.$constant.request.control.datetime && field.value) {
						mappedFormData[field.id] = moment(field.value).isValid() ? moment(field.value).toISOString() : field.value;
					}
					if (!_.isEmpty(field.value) && field.control === this.$constant.request.control.relation && field.value.every(item => typeof item === "object")) {
						mappedFormData[field.id] = field.value.map(item => item.id);
					}
				});

				const payload = {
					id: requestData.id,
					req_type_id: requestData.req_type_id,
					alternative_approvers: requestData.alternative_approvers && requestData.alternative_approvers.length ? JSON.stringify(requestData.alternative_approvers) : null,
					req_status_id: requestData.req_status_id,
					request_reason: requestData.request_reason,
					data: JSON.stringify(mappedFormData)
				};

				const selectedRequestType = this.requestTypesMixin.find(requestType => requestType.id === requestData.req_type_id) || {};
				const isDynamicRequest =
					(requestData && !requestData.id && selectedRequestType && selectedRequestType.statuses && _.isEmpty(selectedRequestType.statuses)) ||
					(requestData && requestData.id && requestData.is_dynamic);
				if (isDynamicRequest) {
					payload.step_status = {
						name: dynamicStepConfig.name,
						notifications: {
							approvers: this.formatStepConfigData(_.get(dynamicStepConfig, "config.approversConfig")),
							reject_notifications: this.formatStepConfigData(_.get(dynamicStepConfig, "config.rejectedNotificationConfig")),
							approve_notifications: this.formatStepConfigData(_.get(dynamicStepConfig, "config.approvedNotificationConfig"))
						}
					};
				}

				const response = await requestGQL.submitRequest({
					...payload,
					relations: relationsData
				});
				resolve(response);
				this.handleOnCreateRequestOrTodoSuccess(response);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleCloneKpis(deviceId) {
			try {
				await this.$store.dispatch("deviceManagement/cloneKpisToDevice", { id: deviceId });
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${this.$t("CreateRemindWork")} ${this.$t("Successful").toLowerCase()}`
					}
				});
			} catch (error) {
				console.error("handleCloneKpis", error);
				this.$helper.notifyError({ context: this, error });
			}
		},
		async handleCreateKpi(data) {
			this.kpiDeviceData = data;
			await this.$store.dispatch("deviceManagement/fetchKpisV2", {});
			this.toggleKpiDialog(true);
		},
		handleResetKpiHour(accessory) {
			console.log("handleResetKpiHour", accessory);
			this.isDialogResetKpi = true;
			this.kpiReset = accessory;
		},
		async resetMaintainHour(reason) {
			const result = await this.$validator.validateAll();
			if (result) {
				this.$vs.loading();
				const payload = {
					device_id: this.detailSidebarData.id,
					kpiv2_id: this.kpiReset.id,
					reason: reason
				};
				try {
					const res = await kpiGql.resetDevice(payload);
					if (res && res.id) {
						await this.handleOnCreateRequestOrTodoSuccess();

						this.$helper.notifySuccess({
							context: this,
							options: {
								text: `${this.$t("Reset")} ${this.$t("Successful").toLowerCase()}`
							}
						});
						this.isDialogResetKpi = false;
						this.kpiReset = null;
					}
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
				}
				this.$vs.loading.close();
			}
		},
		toggleResetDialog() {
			this.isDialogResetKpi = false;
		},
		handleOnCreateTodoSuccess() {
			this.$refs["device-detail"].handleCreateNewTodo();
		}
	},
	created() {
		this.setPageTitleByCategoryId();
		this.syncQuery({
			dataName: "detailCode",
			queryName: "code",
			dataToQuery: {
				immediate: true
			}
		});
		this.$store.registerModule("deviceManagement", moduleDevice);

		this.$store.dispatch("deviceManagement/setDevicesSearchQuery", "");
		this.handleFetchDataByQuery();
	},
	beforeDestroy() {
		this.$store.unregisterModule("deviceManagement");
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/cbs/DevicesManagement.scss";
</style>
